const genderTypes = [
  { id: 1, name: "Feminino" },
  { id: 2, name: "Masculino" },
  { id: 3, name: "Não-Binário" },
  { id: 4, name: "Prefiro não responder" },
  { id: 5, name: "Outro" },
];

export default [...genderTypes];
